<template>
	<tr :class="!localCostItem?.id ? 'blocked-content-cost-table' : ''">
		<td style="vertical-align: middle" :width="colWidths[0]" class="text-left" >
			<div class="d-flex align-center">
				<!-- <v-icon small class="mr-1 cost_table_item_drag_handler" color="black">mdi-unfold-more-horizontal</v-icon> -->
				<v-form ref="formconcept_filled" style="width: 100%;">
					<v-text-field
						v-if="!fromCompanyItem"
						v-model="localCostItem.name"
						:label="inputLabel"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1"
						style="font-size: 14px;"
						:style="'padding-left: ' + paddingLevelForFirstElement"
						:rules="requiredRule"
						:loading="!localCostItem?.id"
						@keydown.enter.prevent
						@input="debounceEmitChange"
					></v-text-field>
					<div v-else class="d-flex align-center" :style="'padding-left: ' + paddingLevelForFirstElement">
						<p class="mb-0 caption">{{localCostItem.name}}</p>
					</div>
				</v-form>
				<div class="d-flex align-center justify-center ml-2" style="min-width: 24px;">
					<v-tooltip bottom v-if="showSubitems">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								x-small
								color="black"
								@click="toggleToShowDetails(localCostItem.id)"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon size="22">mdi-chevron-down</v-icon>
							</v-btn>
						</template>
						<span>Ver Detalle</span>
					</v-tooltip>
					<v-menu offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;" v-if="!fromCompanyItem && costCategoriesConfig">
						<template v-slot:activator="{ on, attrs }">
							<v-tooltip bottom>
								<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
									<v-btn
										icon
										color="warning"
										x-small
										v-bind="{ ...attrs, ...tooltipAttrs }"
										v-on="{ ...on, ...tooltipOn }"
									>
										<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
									</v-btn>
								</template>
								<span>Asignar Costo Base</span>
							</v-tooltip>
						</template>
						<v-list dense class="py-0" max-height="200" style="z-index: 9999; background-color: white;">
							<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
								<p class="caption mb-0 font-weight-bold white--text">Asignar Costo Base</p>
							</v-list-item>

							<!-- Iterar sobre los grupos -->
							<template v-for="(item_config, index) in costCategoriesConfig">
								<v-list-item dense @click="setAsCostCategory(item_config)" :key="index">
									<v-list-item-title>
										<p class="mb-0 caption font-weight-bold">{{ item_config.name }}</p>
									</v-list-item-title>
								</v-list-item>

								<!-- Subitems debajo -->
								<template v-if="showCostStageTypeSelection == item_config.id && item_config.base_stages?.length">
									<v-list-item
										v-for="(base_stage, subIndex) in item_config.base_stages"
										:key="index + '_sub_' + subIndex"
										dense
										class="pl-6"
										@click.stop="setAsCostCategory(item_config, base_stage)"
									>
										<v-list-item-title>
											<p class="mb-0 caption">{{ base_stage.name }}</p>
										</v-list-item-title>
									</v-list-item>
								</template>
							</template>
						</v-list>


						<!-- <v-list dense class="py-0" max-height="200" style="z-index: 9999; background-color: white;">
							<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
								<p class="caption mb-0 font-weight-bold white--text">Asignar Costo Base</p>
							</v-list-item>

							<v-list-item-group color="#524D4D">
								<v-list-item
									v-for="(item_config, index) in costCategoriesConfig"
									:key="index"
									dense
									@click="setAsCostCategory(item_config)"
								>
									<v-list-item-title dense>
										<p class="mb-0 caption">{{ item_config.name }}</p>
									</v-list-item-title>
									<v-list dense v-if="item_config.subitems && item_config.subitems.length" class="pl-4">
										<v-list-item
											v-for="(subitem, subIndex) in item_config.subitems"
											:key="index + '_sub_' + subIndex"
											dense
											@click.stop="handleSubItemClick(subitem)"
										>
											<v-list-item-title dense>
												<p class="mb-0 caption">{{ subitem.name }}</p>
											</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-list-item>
							</v-list-item-group>
						</v-list> -->
					</v-menu>
				</div>
			</div>
		</td>
		<td style="vertical-align: middle;min-width: 100px;" :width="colWidths[1]" class="text-right">
			<div class="d-flex align-center justify-end" v-if="isEditable">
				<v-form ref="formvalue" style="width: 100%;">
					<v-text-field
						v-model="localCostItem.qty"
						type="text"
						:label="isM2Selection ? 'SUPERFICIE m²':'CANTIDAD'"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1 force-no-transform"
						style="font-size: 14px;"
						:rules="requiredRule"
						@keydown.enter.prevent
						@input="sanitizeQty"
					></v-text-field>
				</v-form>
			</div>
			<div class="d-flex align-center justify-end" v-else>
			</div>
		</td>
		<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]" class="text-right">
			<div class="d-flex align-center justify-end" v-if="isEditable && !fromCompanyItem && currency == 'uf'">
				<v-form ref="formvalue" style="width: 100%;">
					<v-text-field
						v-model="localCostItem.unit_cost_uf"
						type="text"
						:label="isM2Selection ? 'VALOR x m² (UF)':'MONTO (UF)'"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1 force-no-transform"
						style="font-size: 14px;"
						:rules="requiredRule"
						@keydown.enter.prevent
						@input="sanitizeUF"
					></v-text-field>
				</v-form>
			</div>
			<div class="d-flex align-center justify-end" v-else>
				{{costItemSummary.unit_cost_uf | toThousandFilter(2)}}
			</div>
		</td>
		<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]" class="text-right">
			<div class="d-flex align-center justify-end" v-if="isEditable && !fromCompanyItem && currency == 'clp'">
				<v-form ref="formvalue" style="width: 100%;">
					<v-text-field
						v-model="localCostItem.unit_cost_clp"
						type="number"
						step="1"
						:label="isM2Selection ? 'VALOR x m² (CLP)':'MONTO (CLP)'"
						outlined
						required
						dense
						hide-details
						class="custom-height-search custom-height-calendar mt-1 force-no-transform"
						style="font-size: 14px;"
						:rules="requiredRule"
						@keydown.enter.prevent
						@keypress="validateCLP"
						@input="sanitizeIntegerInput"
					></v-text-field>
				</v-form>
			</div>
			<div class="d-flex align-center justify-end" v-else>
				${{costItemSummary.unit_cost_clp | toThousandFilter}}
			</div>
		</td>
		<td style="vertical-align: middle;" :width="colWidths[4]" class="text-right">
			{{costItemSummary.total_cost_uf | toThousandFilter(2)}}
		</td>
		<td style="vertical-align: middle;" :width="colWidths[5]" class="text-right">
			${{Math.round(costItemSummary.total_cost_clp) | toThousandFilter}}
		</td>
		<td style="vertical-align: middle;" :width="colWidths[6]" class="text-center">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						dark
						x-small
						color="error"
						@click="deleteItem"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon small dark>mdi-delete-outline</v-icon>
					</v-btn>
				</template>
				<span>Eliminar Item</span>
			</v-tooltip>
		</td>
	</tr>
</template>

<script>
import _debounce from 'lodash/debounce'

export default {
	name: 'CostItemSingle',
	props: {
		costItem: {
			type: Object,
			required: true
		},
		costCategoriesConfig: {
			type: Array,
			required: false
		},
		isM2Selection: {
			type: Boolean,
			default: false
		},
		isEditable: {
			type: Boolean,
			default: true
		},
		showSubitems: {
			type: Boolean,
			default: true
		},
		ufValue: {
			type: Number,
			required: true
		},
		colWidths: {
			type: Array,
			required: true
		},
		itemLevel: {
			type: Number,
			default: 1
		},
		costStageType: {
			type: Number,
			default: null
		},
		inputLabel: {
			type: String,
			default: 'Item'
		},
		currency: {
			type: String,
			required: true
		}
	},
	computed: {
		fromCompanyItem(){
			return this.costItem?.company_item_id || false
		},
		paddingLevelForFirstElement(){
			const basePadding = 8
			const padding = basePadding * this.itemLevel
			return padding + '%'
		},
		costItemSummary() {
			const parse = (n) => parseFloat(n) || 0;

			const summarizeItems = (items) => {
				return items.reduce(
					(acc, item) => {
						if (Array.isArray(item.subitems) && item.subitems.length > 0) {
							const subTotals = summarizeItems(item.subitems);
							acc.qty += subTotals.qty;
							acc.unit_cost_uf += subTotals.unit_cost_uf;
							acc.unit_cost_clp += subTotals.unit_cost_clp;
							acc.total_cost_uf += subTotals.total_cost_uf;
							acc.total_cost_clp += subTotals.total_cost_clp;
						} else {
							const qty = parse(item.qty);
							const uf = parse(item.unit_cost_uf);
							const clp = parse(item.unit_cost_clp);

							acc.qty += qty;
							acc.unit_cost_uf += uf;
							acc.unit_cost_clp += clp;
							acc.total_cost_uf += uf * qty;
							acc.total_cost_clp += clp * qty;
						}

						return acc;
					},
					{
						qty: 0,
						unit_cost_uf: 0,
						unit_cost_clp: 0,
						total_cost_uf: 0,
						total_cost_clp: 0
					}
				);
			};

			const totals = {
				qty: 0,
				unit_cost_uf: 0,
				unit_cost_clp: 0,
				total_cost_uf: 0,
				total_cost_clp: 0
			};
			if (Array.isArray(this.localCostItem.subitems)) {
				const subitemTotals = summarizeItems(this.localCostItem.subitems);
				Object.keys(totals).forEach(k => {
					totals[k] += subitemTotals[k];
				});
			}

			if (
				!Array.isArray(this.localCostItem.subitems)
				|| this.localCostItem.subitems.length === 0
			) {
				const qty = parse(this.localCostItem.qty);
				const uf = parse(this.localCostItem.unit_cost_uf);
				const clp = parse(this.localCostItem.unit_cost_clp);

				totals.qty += qty;
				totals.unit_cost_uf += uf;
				totals.unit_cost_clp += clp;
				totals.total_cost_uf += uf * qty;
				totals.total_cost_clp += clp * qty;
			}

			return totals;
		}
	},
	watch: {
		costItem: {
			handler(newValue, oldValue) {
				if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;
				this.localCostItem = { ...newValue }
				if(this.localCostItem.unit_cost_uf && this.localCostItem.from_change != 'clp'){
					this.setItemClpValueFromUf()
				}
			},
			deep: true,
			immediate: false,
		},
		ufValue: {
			handler() {
				if(this.localCostItem.unit_cost_uf && this.localCostItem.from_change != 'clp'){
					this.setItemClpValueFromUf()
				}
			},
			immediate: true
		}
	},
	data(){
		return {
			showCostStageTypeSelection: false,
			localCostItem: {...this.costItem},
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
		}
	},
	mounted(){
		this.$nextTick(() => {
			if(this.localCostItem.unit_cost_uf && this.localCostItem.from_change != 'clp'){
				this.setItemClpValueFromUf()
			}
		})
	},
	methods: {
		onKeyPress(event){
			if(event.target?.value > 9999999){
				event.preventDefault();
			}
		},
		debounceEmitChange: _debounce(function() { this.emitChange() }, 50),
		emitChange(){
			this.$emit('change', { ...this.localCostItem })
		},
		setAsCostCategory(cost_category){
			this.$emit('change:setCategory', { ...cost_category })
		},
		validateCLP(e) {
			// if (e.key === '.' || e.key === ',' || e.key === 'e') {
			if (e.key === 'e') {
				e.preventDefault()
			}
			if(e.target?.value > 9999999999){
				e.preventDefault();
			}
		},
		sanitizeQty() {
			let value = String(this.localCostItem.qty ?? '')
			if (this.isM2Selection) {
				value = value
					.replace(',', '.')
					.replace(/[^0-9.]/g, '')
					.replace(/(\.\.*)\./g, '$1')
					.replace(/^0+(?=\d)/, '')
			} else {
				value = value
					.replace(/\D/g, '')
					.replace(/^0+(?!$)/, '')
			}

			this.localCostItem = {
				...this.localCostItem,
				qty: value
			}

			if (!this.isM2Selection || (value !== '' && !value.endsWith('.'))) {
				this.debounceEmitChange()
			}
		},
		sanitizeUF() {
			let value = String(this.localCostItem.unit_cost_uf ?? '');
			// Normalizar coma como separador decimal
			value = value.replace(',', '.');
			const isNegative = value.startsWith('-');
			value = value
				.replace(/[^0-9.]/g, '')
				.replace(/^0+(?=\d)/, '');
			// Mantener solo el primer punto decimal
			const parts = value.split('.');
			if (parts.length > 2) {
				value = parts[0] + '.' + parts.slice(1).join('');
			}
			if (isNegative && value !== '') {
				value = '-' + value;
			}
			this.localCostItem = {
				...this.localCostItem,
				unit_cost_uf: value
			};
			// Solo recalcular si el valor es un número completo (no termina en punto)
			if (value !== '' && !value.endsWith('.')) {
				this.setItemClpValueFromUf();
			}
		},
		sanitizeIntegerInput() {
			this.localCostItem = {
				...this.localCostItem,
				unit_cost_clp: this.localCostItem.unit_cost_clp
					.replace(/\D/g, '')
					.replace(/^0+(?!$)/, '') || 0
			}
			this.setItemUfValueFromClp()
		},
		setItemClpValueFromUf(){
			const clp_value = this.localCostItem.unit_cost_uf * this.ufValue
			this.localCostItem = {...this.localCostItem, ...{unit_cost_clp: parseFloat(clp_value), from_change: 'uf'}}
			this.$emit('change', { ...this.localCostItem })
			// this.debounceEmitChange()
		},
		setItemUfValueFromClp(){
			const uf_value = this.localCostItem.unit_cost_clp / this.ufValue
			this.localCostItem = {...this.localCostItem, ...{unit_cost_uf: parseFloat(uf_value), from_change: 'clp'}}
			this.$emit('change', { ...this.localCostItem })
			// this.debounceEmitChange()
		},
		toggleToShowDetails(item_id) {
			this.$emit('onToggleShowDetails', item_id)
		},
		deleteItem(){
			this.$emit('change', null)
		},
	}
}
</script>

<style scoped>
	tr.no-hover-cells,
	tr.no-hover-cells td {
		background-color: inherit !important;
	}
	.square-btn {
		width: 24px !important;
		height: 24px !important;
		min-width: 0 !important;  /* evita que Vuetify imponga min-width de 64px */
		padding: 0 !important;    /* elimina el padding interno */
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.cost_table_item_drag_handler{cursor: grab;}
	/deep/.force-no-transform label{
		text-transform: none !important;
	}
	/deep/ .blocked-content-cost-table td{
		pointer-events: none;
		position: relative;
	}
	/deep/.blocked-content-cost-table td::before{
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0.5;
		background: white;
		z-index: 2;
	}
</style>